import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledText } from '../../../../styles/text';
import { StyledFlex } from '../../../../styles/common';
import PastPromoIllustration from '../../../common/illustrations/past-promo';
const PastPromo = ({ heading }) => (_jsxs(StyledFlex, { alignItems: "center", direction: "column", "data-testid": "past-promo-period", children: [_jsx(PastPromoIllustration, {}), _jsx(StyledText, { as: "h5", size: "regular", color: "black", children: heading })] }));
export default PastPromo;
//# sourceMappingURL=index.js.map